import { Box, Grid, Stack, TextField } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { dateformat } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { FechaField } from '../../../accesos/components/FechaField';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { updateEstatusRecibosAction } from '../RecibosAction';
import { detallesInfoRecibo } from './ListadoRecibos';

const FormUpdateEstatusRecibos = ({ setOpenModalForm, selectEstatus }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const recibosStore = Redux.useSelector((state) => state.recibos);

  const activo = recibosStore.activo;

  const initData = {
    fecha: dateformat(null, {}),
    descEstatus: '',
    idEstatus: selectEstatus ?? 10,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    fecha: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!recibosStore.activo) {
      notify('Falta seleccionar un recibo', { warning: true });
      return;
    }

    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await updateEstatusRecibosAction(
        { dispatch, notify },
        activo?.id,
        data,
        recibosStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  const form = (
    <>
      <Grid item xs={12} md={12}>
        {detallesInfoRecibo(activo)}
      </Grid>
      <Grid item xs={12} md={12}>
        <FechaField
          notDate
          views={['day']}
          openTo="day"
          botonCurrentDate={false}
          label={CONST.fecha.label}
          value={data.fecha}
          error={dataError.fecha}
          onChange={(e) =>
            _handleSetDataField(CONST.fecha.name, dateformat(e, {}))
          }
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <TextField
          fullWidth
          size="small"
          id={CONST.descEstatus.name}
          label={CONST.descEstatus.label}
          value={data.descEstatus}
          multiline
          rows={3}
          onChange={(e) => {
            if (e.target.value.length <= 100) {
              _handleSetDataField(CONST.descEstatus.name, e.target.value);
            }
          }}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        <EstatusField
          value={data.idEstatus}
          onChange={(e) =>
            _handleSetDataField(CONST.estatus.idName, e.target.value)
          }
          required
          error={dataError.estatus}
          allowIds={[8, 9, 10]}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        <Stack alignItems="center" spacing={1}>
          <BotonComponent
            click={_handleSubmit}
            text="GUARDAR"
            disabled={loadingSave}
            green
            saveIcon
          />
        </Stack>
      </Grid>
    </>
  );

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}
        <Grid item xs={12} md={12}>
          <Grid container spacing={2}>
            {form}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormUpdateEstatusRecibos;
